const CustomizedAxisTick = (props) => {
    let { x, y, stroke, payload } = props;

    let parts = payload.value.toString().split(' ');
    let day = parts[0];
    let date = parts.length > 1 ? parts[1] : '';

    let textX = 8;

    if (day == 'Mon' || day == 'Wed') {
        textX = 11;
    }

    return (
        <g transform={`translate(${x + 0},${y - 10})`}>
            <text x={textX} y={0} dy={16} textAnchor="end" fill="#666" style={{ fontSize: 12 }}>
                {day}
            </text>
            <text x={15} y={12} dy={16} textAnchor="end" fill="#666" style={{ fontSize: 12 }}>
                {date}
            </text>
        </g>
    );
}

export default CustomizedAxisTick;